/** @format */

export const IccidRange = {
    ownerPlatformResellerId: null,
    fromImsi: null,
    toImsi: null,
    indicatedRangeId: null,
    iccidType: null,
    tariffId: null,
    indicatedRangeDiscountTemplateId: null,
};

export const IccidRangeStatus = {
    ownerPlatformResellerId: null,
    fromImsi: null,
    toImsi: null,
    indicatedRangeId: null,
    iccidType: null,
    tariffId: null,
    indicatedRangeDiscountTemplateId: null,
};
